export const HACK_TERMINAL_STATUS_COLORS = {
  yellow: "#eeff00",
  red: "#e20000",
  blue: "#00ff88",
};
